import {Button} from '../../components/Button';

interface MyTripsHeaderProps {
  heroImage: string;
  isLoading: boolean;
  latestTripTitle?: string;
  onCreateTrip: () => void;
  isCreatingTrip?: boolean;
  continueHref?: string;
}

/**
 * Hero header section for My Trips page with background image and action buttons.
 */
export const MyTripsHeader = ({
  heroImage,
  isLoading,
  latestTripTitle,
  onCreateTrip,
  isCreatingTrip,
  continueHref,
}: MyTripsHeaderProps) => {
  return (
    <div className="relative bg-neutral-darkest pb-32">
      <div className="absolute inset-0 overflow-hidden">
        {isLoading ? (
          <div className="h-full w-full bg-neutral-dark animate-pulse" />
        ) : (
          <img className="h-full w-full object-cover" src={heroImage} alt="Header background" />
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-neutral-darkest to-transparent" />
      </div>
      <div className="relative mx-auto max-w-7xl py-24 px-4 sm:py-32 sm:px-6 lg:px-8">
        <h1 className="text-4xl tracking-tight text-on-dark md:text-5xl lg:text-6xl drop-shadow-md">
          Your Trips
        </h1>
        <div className="mt-10 flex flex-wrap gap-4">
          <Button
            variant="primary"
            size="lg"
            onClick={onCreateTrip}
            disabled={isCreatingTrip}
            loading={isCreatingTrip}
          >
            + Create New Trip
          </Button>
          {latestTripTitle && continueHref && (
            <Button variant="outline-blurred" size="lg" href={continueHref}>
              Continue <span className="max-w-[200px] truncate mx-1.5">{latestTripTitle}</span>{' '}
              &rarr;
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};
